'use client'

import { Radio as RadioPrimitive } from '@base-ui/react/radio'
import { RadioGroup as RadioGroupPrimitive } from '@base-ui/react/radio-group'
import { cn } from '../lib/utils'

function RadioGroup({ className, ...props }: RadioGroupPrimitive.Props) {
  return (
    <RadioGroupPrimitive
      className={cn('flex flex-col gap-3', className)}
      data-slot="radio-group"
      {...props}
    />
  )
}

function Radio({ className, ...props }: RadioPrimitive.Root.Props) {
  return (
    <RadioPrimitive.Root
      className={cn(
        'radio focus-visible:ring-primary/80 focus-visible:ring-offset-surface-1 outline-none focus-visible:ring-2 focus-visible:ring-offset-2 data-disabled:opacity-64 [@media(hover:none)]:data-disabled:pointer-events-none',
        // Per-option quiz feedback must outrank the checked state. The dot
        // (::before) and ring (::after) are pseudo-elements so they can't be
        // pure utilities — drive their color via --radio-feedback-color,
        // which index.css reads (see .radio there for why).
        'data-[feedback=error]:border-error data-[feedback=success]:border-success data-[feedback=error]:[--radio-feedback-color:var(--error)] data-[feedback=success]:[--radio-feedback-color:var(--success)]',
        // Feedback is shown on a submitted, disabled field — keep it fully opaque.
        'data-[feedback]:data-disabled:opacity-100',
        className,
      )}
      data-slot="radio"
      {...props}
    >
      <RadioPrimitive.Indicator
        className="sr-only"
        data-slot="radio-indicator"
      />
    </RadioPrimitive.Root>
  )
}

export { RadioGroup, Radio, Radio as RadioGroupItem }
